import { getQualityOptions } from '@components/QualitySelection/config';
import Camera from '@fragments/Camera';
import Microphone from '@fragments/Microphone';
import Speaker from '@fragments/Speaker';
import type { VideoQuality } from '@hooks/sdk/useSelectVideoQuality';
import useSelectVideoQuality from '@hooks/sdk/useSelectVideoQuality';
import {
  useAudioInputs,
  useAudioOutputs,
  useVideoInputs,
} from '@providers/DevicesProvider';
import { useMeetingManager } from '@providers/MeetingProvider';
import { useEffect } from 'react';
import { Content } from './style';

const Device = () => {
  const { devices: audioOutputDevices } = useAudioOutputs();
  const { devices: audioInputDevices } = useAudioInputs();
  const { devices: videoInputDevices } = useVideoInputs();
  const meetingManager = useMeetingManager();
  const selectVideoQuality = useSelectVideoQuality();

  useEffect(() => {
    if (
      audioOutputDevices.length > 0 &&
      audioInputDevices.length > 0 &&
      videoInputDevices.length > 0 &&
      getQualityOptions.length > 0
    ) {
      (async () => {
        meetingManager.selectVideoInputDevice(videoInputDevices[0].deviceId);

        await meetingManager.startAudioInputDevice(
          audioInputDevices[0].deviceId,
        );

        await meetingManager.startAudioOutputDevice(
          audioOutputDevices[0].deviceId,
        );

        selectVideoQuality(getQualityOptions[0].value as VideoQuality);
      })();
    }
  }, [
    audioOutputDevices,
    audioInputDevices,
    videoInputDevices,
    meetingManager,
    selectVideoQuality,
  ]);

  return (
    <Content>
      <Speaker />
      <Microphone />
      <Camera />
    </Content>
  );
};

export default Device;
